<template>
    <div>
        <div class="option-title" v-if='!showPlaneMode'>Divulgação / Marketing</div>
        <div class="option-title-edit" v-else>
            <ul>
                <li><strong>Divulgação / Marketing</strong></li>
            </ul>
        </div>
        <div class="frame-option" :class="[!showPlaneMode ? 'disable-styles px-4' : 'edit-styles']">
            <li>
                <p>
                    Além da produção e da logística, nossas parcerias vão contar com todo o nosso
                    time de tecnologia e atendimento para dar o suporte necessário. Entretanto,
                    <strong>fica como responsabilidade do parceiro</strong>
                    toda a estratégia de vendas e gerenciamento das redes sociais para atrair o
                    público e divulgar os produtos.
                </p>
            </li>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MktTerms',

        props: {
            showPlaneMode: {
                default: false,
                type: Boolean,
            },
        },
    };
</script>
